import styled from 'styled-components'

export const Section = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

export const Item = styled.div``

export const QuantityAndDeleteRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const QuantityFieldWrapper = styled.div`
  flex: 1;
`

export const AddButton = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;

  svg {
    width: 10px;
    height: 10px;
  }
`
